export const baseURL = process.env.REACT_APP_BASE_URL;


// export const appURL = "https://talentspotifyapp.com/api";
// export const appURL = "http://localhost:4000/api";
// Same origin in every environment: nginx serves the app and proxies /api to the backend.
export const appURL = "/api";

export const PsychometricURL = "/api";


// export const UiURL="https://talentspotifyapp.com"

export const UiURL = window.location.origin;

export const taraURL = process.env.REACT_APP_TARA_URL || window.location.origin;
